import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Container, Col, Row, Button, Form } from "react-bootstrap";
import { Spinner } from "react-bootstrap";
import {
  getDemoDatabaseBackups,
  putRestoreSavedDemoDatabase,
} from "../../../Services/DemoServices";
import { ConformationModal } from "../../../Components/ConformationModal";
import { toast } from "react-toastify";
import Logout from "../../../Services/LogoutService";

export const AdminDemoRestore = () => {
  const history = useHistory();

  const [showLoader, setShowLoader] = useState(false);
  const [savedDemos, setSavedDemos] = useState([]);
  const [showOverwriteWarning, setShowOverwriteWarning] = useState(false);
  const [restoreSavedDemoId, setRestoreSavedDemoId] = useState(0);

  useEffect(() => {
    getDemoDatabaseBackups()
      .then((res) => {
        var result = JSON.parse(res.response);
        result.sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        setSavedDemos(result);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const doLogout = () => {
    Logout();
    sessionStorage.clear();
    history.push(process.env.PUBLIC_URL + "/home");
  };

  const restoreDemo = () => {
    setShowOverwriteWarning(false);

    putRestoreSavedDemoDatabase({ id: restoreSavedDemoId })
      .then((_) => {
        toast.success("Demo site restored successfully. Logging out...");
        setTimeout(() => doLogout(), 4000);
      })
      .catch((err) => {
        toast.error("Unable to restore demo site.");
        setTimeout(() => setShowLoader(false), 3000);
      });
  };

  const handleUserClickedRestore = () => {
    setShowLoader(true);
    setShowOverwriteWarning(true);
  };

  return (
    <>
      <Container>
        <h1 className="page-title">Restore A Saved Demo</h1>
        <div className="dashboard-wrapper">
          <Row className="justify-content-md-center">
            <Col sm={12} md={6} className="mt-0">
              <div className="dashboard-box dashboard-col-bg mb-4">
                <h2 className="sub-form-title mb-6 d-flex">Restore Demo</h2>
                <p className="m-0">
                  Restoring a saved demo will reset the demo to the
                  exact state it was when saved. The current demo will
                  be overwritten, and the saved demo that you select will be
                  loaded.
                </p>

              <p></p>

                <p className="font-italic mt-1">
                  It’s suggested that you save a copy of the current demo if
                  you want to use it again.
                </p>

                <p className="mt-4 mb-0 font-weight-bold">
                  Select a saved demo to restore:
                </p>
                <Row>
                  <Col md={12}>
                    <Form.Group controlId="dd">
                      <Form.Control
                        as="select"
                        name="restore-saved-demo"
                        value={restoreSavedDemoId}
                        disabled={true === showLoader}
                        onChange={(e) =>
                          setRestoreSavedDemoId(parseInt(e.target.value))
                        }
                        className="inputclass form-control"
                      >
                        <option value="0">Select A Saved Demo</option>
                        {savedDemos.map((item, index) => (
                          <option key={"sd-" + index} value={item.demoResetId}>
                            {item.name}
                          </option>
                        ))}
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="mt-4">
                    <Button
                      type="button"
                      className="btn btn-danger"
                      disabled={restoreSavedDemoId <= 0 || true === showLoader}
                      onClick={() => {
                        handleUserClickedRestore();
                      }}
                    >
                      {showLoader ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        "Restore"
                      )}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <ConformationModal
        show={showOverwriteWarning}
        onHide={() => setShowOverwriteWarning(false)}
        onPrimary={() => restoreDemo()}
        onSecondary={() => {
          setShowOverwriteWarning(false);
          setShowLoader(false);
        }}
        showSecondary={true}
        primaryText="Continue"
        secondaryText="Cancel"
        title="Restore Saved Demo Site?"
        bodyText="Restoring a saved Demo will erase the current demo. Do you want to continue?"
      />
    </>
  );
};
